<script>
    import ModalTrigger from "./ModalTrigger.svelte";
    import TechLabel from "./TechLabel.svelte";
    import ModalImages from "./ModalImages.svelte";
    export let project;

    const projectName = () => {
        if (project.id.length <= 0) {
            return 'Image';
        }
        return project.id.charAt(0).toUpperCase() + project.id.slice(1).replace('_', ' ');
    }; 
</script>

<div class="portfolio_item">
    <figure class="portfolio_item__image_cnt">
        <ModalTrigger project_data={ project }>
            <img alt="{ projectName() }"
                data-sizes="auto"
                data-lowsrc="{ project.images.thumbnails.thumbnail_sm }"
                data-srcset="{ project.images.thumbnails.thumbnail_sm } 100w, { project.images.thumbnails.thumbnail_lg } 600w"
                class="mediabox-img lazyload">
        </ModalTrigger> 
        <ModalImages { project } />
        <div class="p-relative portfolio_item__footer">
            {#if project.links.project !== undefined && project.links.project !== '' && project.links.project !== null}
            <a href="{ project.links.project }" target="_blank" class="p-absolute site_link">Visit site</a>
            {/if}
            {#if project.images.technology.length > 0}
                <TechLabel labels={ project.images.technology }/>
            {/if}
            <svg version="1.1" class="p-absolute project_footer_svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 600 150" style="enable-background:new 0 0 600 150;" xml:space="preserve">
                <style type="text/css">
                    .st1{fill:none;stroke-width:4;stroke-miterlimit:10;}
                    .st2{fill:none;stroke-miterlimit:10;}
                </style>
                <rect x="-51" y="19" transform="matrix(0.9986 -5.233750e-02 5.233750e-02 0.9986 -3.5457 15.5949)" class="project_footer_svg__rect" width="694" height="113"/>
                <g>
                    <line class="st1 project_footer_svg__line" x1="0.4" y1="147.7" x2="600" y2="116.3"/>
                    <line class="st2 project_footer_svg__line" x1="0.4" y1="147.7" x2="600" y2="116.3"/>
                </g>
            </svg>
        </div>
    </figure>
</div>

<style lang="scss">
    .portfolio_item{
        flex: 1 1 33.333%;
        max-width: 33.333%;
        padding-left: 0.4rem;
        padding-right: 0.4rem;
        &__image_cnt{
            overflow: hidden;
            margin: 0;
        }
        &__footer{
            transform: translate3d(-2%, -25%, 0);
            height: 0;
            padding-bottom: 25%;
            z-index: 20;
            width: 104%;
            background-size: 100% 100%;
            padding-left: 2%;
            padding-right: 2%;
        }
    }
    .site_link{
        font-size: 1.4rem;
        top: 0;
        z-index: 30;
        transform: rotate(-3deg) skew(-3deg) translateY(-65%);
        left: 3%;
        background-color: rgba(255, 255, 255, 0.7);
    }
    .project_footer_svg{
        z-index: 10;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        pointer-events: none;
    }
    @media screen and (max-width: 960px) {
        .portfolio_item{
            flex-basis: 50%;
            max-width: 50%;
        }
    }
    @media screen and (max-width: 600px) {
        .portfolio_item{
            flex-basis: 100%;
            max-width: 100%;
        }
    }
</style>